import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Button, CircularProgress, Alert, Box } from '@mui/material';
import { toast } from 'react-toastify';
import StripeCheckoutSession from '../../../graphql/mutations/StripeCheckoutSession';

const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY || 'pk_live_51OfWdnAC55tlYvchY1VZ2jLepn7jiUefGZlcnd6npWXTGkpITPlyWH2JKM0cHeb6r3GTfBaPLCM3fCCBBPJyHvZP00d7W6HwTr');

export function CheckoutButton({ priceId, buttonProps = {}, children = 'Subscribe' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClick = () => {
    setLoading(true);
    setError('');

    StripeCheckoutSession.commit({ priceId }).then(({ stripeCheckoutSession }) => {
      const { sessionId, error: stripeError } = stripeCheckoutSession || {};

      if (sessionId) {
        stripePromise.then((stripe) => {
          stripe.redirectToCheckout({ sessionId });
        });
      } else {
        setError(stripeError || 'Something went wrong');
        toast.error(stripeError || 'Unable to initiate checkout session');
        setLoading(false);
      }
    }).catch((err) => {
      setError(err.message || 'Unexpected error');
      toast.error(err.message || 'An unexpected error occurred.');
      setLoading(false);
    });
  };

  return (
    <Box sx={{ mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Button
        variant="outlined"
        color="primary"
        disabled={loading}
        onClick={handleClick}
        {...buttonProps}
      >
        {loading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
        {children}
      </Button>
    </Box>
  );
}
